import { useState, useEffect } from 'react'
import config from '../Chatbot/config'
import { initialMessageApi } from '../Services/searchRequest'
import DefaultMessageStrategy from '../Strategies/defaultMessageStrategy'

export const useInitialMessages = () => {
  const [botConfig, setBotConfig] = useState(null)

  useEffect(() => {
    let isMounted = true
    const fetchInitialMessage = async () => {
      try {
        const initialMessage = await initialMessageApi()
        if (isMounted) {
          updateBotConfig(initialMessage)
        }
      } catch (error) {
        console.error("Error fetching initialMessage", error)
        if (isMounted) {
          updateBotConfig(null)
        }
      }
    }
    const updateBotConfig = (messageData) => {
      const initialMessages = DefaultMessageStrategy.execute(messageData)

      setBotConfig({
        ...config,
        initialMessages: initialMessages.map((msg) => ({
          ...msg,
          type: "custom",
          name: "CustomMessageBot"
        })),
      })
    }
    fetchInitialMessage()

    return () => {
      isMounted = false
    }
  }, [])
  return { botConfig }
}